import React from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';
import { Translate } from '@hydra/common/components';
import get from 'lodash/get';

import CrawlerTable from '@hydra/routes/crawler/components/CrawlerTable';
import ContentIssueRow from '../ContentIssueRow';

import FilterContainer from '@hydra/routes/crawler/components/FilterContainer';
import FilterCheckboxes from '@hydra/routes/crawler/components/FilterCheckboxes';
import FilterString from '@hydra/routes/crawler/components/FilterString';
import Order from '@hydra/routes/crawler/components/Order';
import { withFilters } from '@hydra/routes/crawler/components/withFilters';

export class ContentIssueTable extends React.Component {
  static propTypes = {
    relay: PropTypes.object,
    project: PropTypes.shape({
      crawl: PropTypes.shape({
        onpageCategory: PropTypes.shape({
          countTypesContentIssues: PropTypes.arrayOf(
            PropTypes.shape({
              count: PropTypes.number,
              severity: PropTypes.number,
              type: PropTypes.string
            })
          ),
          contentIssues: PropTypes.shape({
            count: PropTypes.number,
            edges: PropTypes.arrayOf(
              PropTypes.shape({
                node: PropTypes.shape({
                  __dataID__: PropTypes.string,
                  severity: PropTypes.number,
                  content_len_wrd: PropTypes.number,
                  type: PropTypes.string,
                  urls: PropTypes.array
                })
              })
            )
          })
        })
      })
    }).isRequired,
    offset: PropTypes.number,
    limit: PropTypes.number
  }

  render () {
    const toggles = get(this.props.project, 'crawls.edges[0].node.countTypesContentIssues', [])
      .map(v => ({ identifier: v.type, ...v }));
    return (
      <>
        <FilterContainer>
          <FilterCheckboxes
            onChange={this.props.onGraphQLCheckboxInputChange('typeFilters', toggles)}
            checkedItems={this.props.filters.typeFilters}
            groups={toggles}
            name='typeFilters'
            label={<Translate content='crawler_body_content_issue' />}
          />

          <FilterString
            onChange={this.props.onGraphQLInputChange('url')}
            value={this.props.filters.url}
            name='url'
            label={<Translate content='crawler_error_page_url' />}
          />
        </FilterContainer>
        <CrawlerTable {...this.props} category='onpageCategory' section='contentIssues'>
          <CrawlerTable.TableHead>
            <Translate content='crawler_body_content_issue' size='2' />
            <Order
              size='1'
              onChange={this.props.onOrderChange('lenOrder')}
              order={this.props.order.lenOrder}
            >
              <Translate content='crawler_words' />
            </Order>
            <Translate content='crawler_error_page_url' size='9' />
          </CrawlerTable.TableHead>
          <CrawlerTable.Body component={ContentIssueRow} />
        </CrawlerTable>
      </>
    );
  }
}

const WithFiltersTable = (withFilters)(ContentIssueTable);

export default createRefetchContainer(
  WithFiltersTable,
  {
    project: graphql`
      fragment ContentIssueTable_project on Project
      @argumentDefinitions(
        offset: {type: "Int", defaultValue: 0},
        limit: {type: "Int", defaultValue: 20},
        typeFilters: {type: "[String]", defaultValue: []},
        lenOrder: {type: "Int", defaultValue: 0},
        url: {type: "TextFilters", defaultValue: { operator: AND, values: [] }}
      ) {
        host,
        crawls (offset: 0, limit: 1) {
          edges {
            node {
              countTypesContentIssues(url: $url) {
                type
                severity
                count
              },
              contentIssues(offset: $offset, limit: $limit, typeFilters: $typeFilters, url: $url, lenOrder: $lenOrder) {
                count
                edges {
                  node {
                    ...ContentIssueRow_issue
                  }
                }
              }
            }
          }
        }
      }
    `
  },
  graphql`
      query ContentIssueTable_RefetchQuery(
        $offset: Int,
        $limit: Int,
        $typeFilters: [String],
        $lenOrder: Int,
        $url: TextFilters,
        $host: String!
      ) {
        project (host: $host) {
          ...ContentIssueTable_project @arguments(
            offset: $offset,
            limit: $limit,
            typeFilters: $typeFilters,
            url: $url,
            lenOrder: $lenOrder
          )
        }
      }
    `
);
